module.exports = __webpack_public_path__ + "static/media/BuilderBanner.9559fbee.svg";